import gql from 'graphql-tag';

export const getAllOrdersQuery = () => gql`
  query {
    allOrders {
      openSwaps {
        orderId
        swapName
        version
        basketVersion
        basketId
        client
        counterParty
        notional
        status
        modifiedDate
        createdBy
        message
        delayed
      }
      closedSwaps {
        orderId
        swapName
        version
        basketVersion
        basketId
        client
        counterParty
        notional
        status
        modifiedDate
        createdBy
        settlementDate
        maturityDate
      }
    }
  }
`;

export const getInActiveOrdersQuery = (fromDate: string, toDate: string) => gql`
  query {
    inactiveOrders(fromDate: "${fromDate}", toDate: "${toDate}") {
      orderId
      swapName
      version
      basketId
      basketVersion
      client
      counterParty
      notional
      status
      message
      modifiedDate
      createdBy
      settlementDate
    }
  }
`;

export const getHolidaysQuery = (countryShortCode: string, year: string) => gql`
  query {
    allHolidays(countryShortCode:"${countryShortCode}", year:"${year}") {
        Id
        country
        countryShortCode
        calendarType
        year
        holidayDate
        holidayName
    }
  }
`;

export const getHolidaysByCurrencyQuery = (currency: string, year: string) => gql`
  query {
    allHolidaysByCurrency(currency: "${currency}", year: "${year}") {
      Id
      country
      countryShortCode
      calendarType
      year
      holidayDate
      holidayName
    }
  }
`;
